























import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography, Surface } from '@/components/atoms';

import { StartGuideCardNeedHelp } from '@/models/start-guide';
import CloseIcon from '@/components/icons/Close.vue';

@Component({
  components: {
    Typography,
    Surface,
    CloseIcon
  }
})
export default class NeedHelpItem extends Vue {
  @Prop({ default: () => ({}) })
  needHelp!: StartGuideCardNeedHelp;

  goTo() {
    if (this.needHelp.link) {
      window.open(this.needHelp.link, '_blank');
    }
  }

  async closeHelpItem() {
    // [WIP] Set dismiss
  }
}
